// TODO: Replace react-reveal Fade with FadeInOnView component for bundle size reduction
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import Container from "../components/Container/Container";
import { useTranslation } from "react-i18next";
import H1 from "../components/H1/H1";
import P from "../components/P/P";
import DefaultSwiper from "../components/DefaultSwiper/DefaultSwiper";
import EmptyAnimation from "../components/Empty/EmptyAnimation";
import GridSwiper from "../components/GridSwiper/GridSwiper";
import { getSafe } from "../utils";
import Spacer from "../components/Spacer/Spacer";
import isMobile from "ismobilejs";
import { useFetchPlaces } from "../hooks/useFetchPlaces";
import { useFetchExperiences } from "../hooks/useFetchExperiences";
import { useFetchCircuits } from "../hooks/useFetchCircuits";
// Temporary Fade fallback component until migration to FadeInOnView
const Fade = ({ children }) => <>{children}</>;
function Favorites() {
  const { favorites } = useSelector((state) => state.Favorites);
  const { data: circuits = [] } = useFetchCircuits();
  const { data: placesResult } = useFetchPlaces();
  const places = useMemo(() => placesResult?.places ?? [], [placesResult]);
  const { data: experiences = [] } = useFetchExperiences();
  let { t } = useTranslation();
  const [filteredCircuits, setFilteredCircuits] = useState([]);
  const [filteredPlaces, setFilteredPlaces] = useState([]);
  const [filteredExp, setFilteredExp] = useState([]);
  useEffect(() => {
    setFilteredCircuits(
    circuits.filter((p) => favorites.circuits.indexOf(p._id) > -1)
    );
    setFilteredPlaces(places.filter((p) => favorites.pois.indexOf(p._id) > -1));
    setFilteredExp(
      experiences.filter((p) => favorites.experiences.indexOf(p._id) > -1)
    );
  }, [
  circuits,
  favorites.circuits,
    places,
    experiences,
    favorites.experiences,
    favorites.pois,
  ]);
  const { local } = useSelector((state) => state.Local);
  return (
    <>
      <Fade>
        <Container>
          {!isMobile().phone && <Spacer bottom="40px" />}
          <H1 big bold>
            {t("favoritesTitle")}
          </H1>
          <P squeeze>{t("favoritesIntro")}</P>
        </Container>
      </Fade>
      <Spacer bottom="10rem" />

      <Fade>
        {filteredExp.length === 0 &&
          filteredCircuits.length === 0 &&
          filteredPlaces.length === 0 && <EmptyAnimation />}
      </Fade>
      <Fade>
        {filteredExp.length !== 0 && (
          <DefaultSwiper
            slides={filteredExp}
            getSafe={getSafe}
            local={local}
            exp
            main={t("topExperience")}
            sub={t("topExperiencesub")}
          />
        )}
      </Fade>
      <Spacer bottom="10rem" />
      <Fade>
        {filteredCircuits.length !== 0 && (
          <GridSwiper
            grid
            getSafe={getSafe}
            slides={filteredCircuits}
            local={local}
            main={t("itineraire")}
            sub={t("itinerairedesc")}
          />
        )}
      </Fade>
      <Spacer bottom="10rem" />
      <Fade>
        {filteredPlaces.length !== 0 && (
          <DefaultSwiper
            slides={filteredPlaces}
            getSafe={getSafe}
            local={local}
            todo
            main={t("todo")}
            sub={t("tododesc")}
          />
        )}
      </Fade>
    </>
  );
}

export default Favorites;
